import { Form, Dropdown, DropdownMenu } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders } from '@fortawesome/free-solid-svg-icons';

export function SurveyResultsConfig(props) {
    return (
        <Dropdown drop="down">
            <Dropdown.Toggle as="span" id="settings-dropdown" className="navbar-button-secondary btn btn-sm btn-outline-primary">
                <FontAwesomeIcon className="h-100 w-100" pointerEvents={"none"} icon={faSliders} />
            </Dropdown.Toggle>
            <DropdownMenu align='end'>
                { props.showLevelToggle && 
                    <div className="dropdown-custom-item">
                        <Form.Check 
                            type="switch" 
                            label="Level"
                            checked={props.showLevel} 
                            onChange={(event) => props.toggleShowLevel(event.target.checked)} 
                        />
                    </div>
                }
                <div className="dropdown-custom-item">
                    <Form.Check 
                    type="switch" 
                    label="Function"
                    checked={props.showFunction} 
                    onChange={(event) => props.toggleShowFunction(event.target.checked)} 
                    />
                </div>
                <Dropdown.Divider />
                <div className='dropdown-custom-item'>
                    <Form.Check 
                    type="switch" 
                    label="Score"
                    checked={props.showAverageScore} 
                    onChange={(event) => props.setShowAverageScore(event.target.checked)} 
                    />
                </div>
                <div className='dropdown-custom-item'>
                    <Form.Check 
                    type="switch" 
                    label="Spread"
                    checked={props.showDegreeOfAlignment} 
                    onChange={(event) => props.setShowDegreeOfAlignment(event.target.checked)} 
                    />
                </div>
            </DropdownMenu>
        </Dropdown>
    );
}